// import React from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import styles from "./NewTestimonial.module.scss";
// import "swiper/css";
// import "swiper/css/navigation";
// import { Autoplay, Navigation } from "swiper/modules";
// import TestimonialImg from "../../../assets/new-images/testimonial-img.png";
// import { testimonialReviews } from "../../../constants";

// const NewTestimonial = () => {
//   return (
//     <div>
//       <Swiper
//         direction="vertical"
//         loop={true}
//         slidesPerView={3}
//         autoplay={{
//           delay: 2000,
//           disableOnInteraction: false,
//         }}
//         speed={1000}
//         modules={[Autoplay]}
//         className="new_testimonial_swiper"
//       >
//         {testimonialReviews?.map((item) => (
//           <SwiperSlide key={item.id}>
//             <div className={styles.new_testimonial_card}>
//               <img
//                 src={item.image}
//                 alt={item.text}
//                 className="testimonial_image"
//               />{" "}
//               <div className={styles.testimonial_user}>
//                 <svg
//                   fill="#cccccc"
//                   version="1.1"
//                   id="Capa_1"
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="50px"
//                   height="50px"
//                   viewBox="0 0 45.532 45.532"
//                   stroke="#cccccc"
//                 >
//                   <g id="SVGRepo_bgCarrier" strokeWidth="0" />

//                   <g
//                     id="SVGRepo_tracerCarrier"
//                     stroke-linecap="round"
//                     stroke-linejoin="round"
//                   />

//                   <g id="SVGRepo_iconCarrier">
//                     {" "}
//                     <g>
//                       {" "}
//                       <path d="M22.766,0.001C10.194,0.001,0,10.193,0,22.766s10.193,22.765,22.766,22.765c12.574,0,22.766-10.192,22.766-22.765 S35.34,0.001,22.766,0.001z M22.766,6.808c4.16,0,7.531,3.372,7.531,7.53c0,4.159-3.371,7.53-7.531,7.53 c-4.158,0-7.529-3.371-7.529-7.53C15.237,10.18,18.608,6.808,22.766,6.808z M22.761,39.579c-4.149,0-7.949-1.511-10.88-4.012 c-0.714-0.609-1.126-1.502-1.126-2.439c0-4.217,3.413-7.592,7.631-7.592h8.762c4.219,0,7.619,3.375,7.619,7.592 c0,0.938-0.41,1.829-1.125,2.438C30.712,38.068,26.911,39.579,22.761,39.579z" />{" "}
//                     </g>{" "}
//                   </g>
//                 </svg>
//                 <div>
//                   {" "}
//                   <h4>{item.name}</h4>
//                   <small>{item.date}</small>
//                 </div>
//               </div>
//               <p>{item.text}</p>
//             </div>
//           </SwiperSlide>
//         ))}
//       </Swiper>
//     </div>
//   );
// };

// export default NewTestimonial;



import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import styles from "./NewTestimonial.module.scss";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay } from "swiper/modules";
import { testimonialReviews } from "../../../constants";

const NewTestimonial = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [direction, setDirection] = useState(isMobile ? "horizontal" : "vertical");
  const [slidesToShow, setSlidesToShow] = useState(isMobile ? 1 : 3);
  const [autoPlay, setAutoplay] = useState(isMobile ? 4000 : 2000);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      setDirection(mobile ? "horizontal" : "vertical");
      setSlidesToShow(mobile ? 1 : 3);
      setAutoplay(isMobile ? 4000 : 2000);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <Swiper
        direction={direction}
        loop={true}
        slidesPerView={slidesToShow}
        autoplay={{
          delay: autoPlay,
          disableOnInteraction: false,
        }}
        speed={1000}
        modules={[Autoplay]}
        className="new_testimonial_swiper"
      >
        {testimonialReviews?.map((item) => (
          <SwiperSlide key={item.id}>
            <div className={styles.new_testimonial_card}>
              <img
                src={item.image}
                alt={item.text}
                className="testimonial_image"
              />
              <div className={styles.testimonial_user}>
                <svg
                  fill="#cccccc"
                  width="50px"
                  height="50px"
                  viewBox="0 0 45.532 45.532"
                  stroke="#cccccc"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g>
                    <path d="M22.766,0.001C10.194,0.001,0,10.193,0,22.766s10.193,22.765,22.766,22.765c12.574,0,22.766-10.192,22.766-22.765 S35.34,0.001,22.766,0.001z M22.766,6.808c4.16,0,7.531,3.372,7.531,7.53c0,4.159-3.371,7.53-7.531,7.53 c-4.158,0-7.529-3.371-7.529-7.53C15.237,10.18,18.608,6.808,22.766,6.808z M22.761,39.579c-4.149,0-7.949-1.511-10.88-4.012 c-0.714-0.609-1.126-1.502-1.126-2.439c0-4.217,3.413-7.592,7.631-7.592h8.762c4.219,0,7.619,3.375,7.619,7.592 c0,0.938-0.41,1.829-1.125,2.438C30.712,38.068,26.911,39.579,22.761,39.579z" />
                  </g>
                </svg>
                <div>
                  <h4>{item.name}</h4>
                  <small>{item.date}</small>
                </div>
              </div>
              <p>{item.text}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default NewTestimonial;
